/*
 * Rescuevation · Vlitex-Kollektion (Familie vlk)
 * Alles hier ist Zugabe: ohne dieses Skript stehen Stationen, Phasen und
 * Stufen vollständig untereinander und alle Links funktionieren als Anker.
 *
 * 1. Betriebsrundgang: Stationen werden zu Reitern (Liste + Lageplan).
 * 2. Schutzkette und Energie-Skala: markiert das gerade sichtbare Glied.
 * 3. Links mit data-vlk-interesse / data-vlk-angebot haken im Formular die
 *    passende Option an und füllen den Nachrichtentext vor.
 * 4. Kaufformulare [data-vlk-kauf] legen per AJAX in die Kassen-Schublade.
 * 5. Szene [data-vlk-szene] startet beim Hereinscrollen, Schutzkette zeigt Fortschritt.
 */
(function () {
  'use strict';

  function rundgang(root) {
    if (root.dataset.vlkBereit) return;
    root.dataset.vlkBereit = '1';
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-vlk-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-vlk-panel]'));
    var zonen = Array.prototype.slice.call(root.querySelectorAll('[data-vlk-zone]'));
    if (tabs.length < 2 || tabs.length !== panels.length) return;

    var liste = root.querySelector('[data-vlk-tabliste]');
    if (liste) {
      liste.setAttribute('role', 'tablist');
      Array.prototype.forEach.call(liste.children, function (li) { li.setAttribute('role', 'presentation'); });
    }
    tabs.forEach(function (t, i) {
      t.setAttribute('role', 'tab');
      t.setAttribute('aria-controls', panels[i].id);
      panels[i].setAttribute('role', 'tabpanel');
      panels[i].setAttribute('aria-labelledby', t.id);
    });
    root.classList.add('is-tabs');

    function zeige(i, opts) {
      opts = opts || {};
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', j === i ? 'true' : 'false');
        t.tabIndex = j === i ? 0 : -1;
      });
      panels.forEach(function (p, j) {
        if (j === i) {
          p.hidden = false;
          if (opts.animiert) {
            p.classList.remove('is-neu');
            void p.offsetWidth;
            p.classList.add('is-neu');
          }
        } else {
          p.hidden = true;
        }
      });
      zonen.forEach(function (z) { z.classList.toggle('is-aktiv', z.getAttribute('data-vlk-zone') === String(i)); });
      if (opts.fokus) tabs[i].focus();
      if (opts.sichtbar) {
        var tab = tabs[i];
        if (tab.scrollIntoView && window.matchMedia('(max-width: 989px)').matches) {
          tab.scrollIntoView({ block: 'nearest', inline: 'center' });
        }
      }
    }

    tabs.forEach(function (t, i) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        zeige(i, { animiert: true, sichtbar: true });
      });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (e.key === 'Home') n = 0;
        if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) {
          e.preventDefault();
          zeige(n, { animiert: true, fokus: true, sichtbar: true });
        }
      });
    });
    zonen.forEach(function (z) {
      z.addEventListener('click', function (e) {
        e.preventDefault();
        zeige(parseInt(z.getAttribute('data-vlk-zone'), 10), { animiert: true, sichtbar: true });
      });
    });

    var start = 0;
    if (location.hash) {
      panels.forEach(function (p, j) { if ('#' + p.id === location.hash) start = j; });
    }
    zeige(start);
  }

  function beobachte(root, zielSel, markerSel, attrZiel, attrMarker) {
    if (root.dataset.vlkBereit || !('IntersectionObserver' in window)) return;
    root.dataset.vlkBereit = '1';
    var marker = Array.prototype.slice.call(root.querySelectorAll(markerSel));
    var ziele = Array.prototype.slice.call(root.querySelectorAll(zielSel));
    if (!marker.length || !ziele.length) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        var nr = e.target.getAttribute(attrZiel);
        marker.forEach(function (m) { m.classList.toggle('is-aktiv', m.getAttribute(attrMarker) === nr); });
      });
    }, { rootMargin: '-40% 0px -50% 0px' });
    ziele.forEach(function (z) { io.observe(z); });
  }

  /* Hakt die passende Formular-Option an. Toleranter Abgleich, damit
     "Vlitex PREMIUM Brandbegrenzungshaube" die Option "Brandbegrenzungshaube"
     trifft. Der Prüfwand-Button (rescu-as-pruefung) setzt "Prüfberichte". */
  function hakeOptionen(wert) {
    if (!wert) return;
    var w = wert.toLowerCase();
    var optionen = document.querySelectorAll('[data-vlk-interesse-option]');
    Array.prototype.forEach.call(optionen, function (o) {
      var opt = (o.getAttribute('data-vlk-interesse-option') || '').toLowerCase();
      if (opt && (w.indexOf(opt) !== -1 || opt.indexOf(w) !== -1)) o.checked = true;
    });
  }

  /* Füllt den Nachrichtentext vor, solange der Besucher selbst nichts geschrieben hat. */
  function fuelleNachricht(text) {
    var form = document.getElementById('ContactForm');
    if (!form || !text) return;
    var feld = form.querySelector('[data-vlk-nachricht]') || form.querySelector('textarea');
    if (!feld) return;
    if (feld.value.trim() === '' || feld.getAttribute('data-vlk-auto') === feld.value) {
      feld.value = text;
      feld.setAttribute('data-vlk-auto', text);
      feld.classList.add('ist-vorbefuellt');
    }
  }

  function interesse(e) {
    if (!e.target.closest) return;
    var link = e.target.closest('[data-vlk-interesse], [data-vlk-angebot]');
    if (link) {
      var angebot = link.getAttribute('data-vlk-angebot');
      if (angebot !== null) {
        var name = angebot;
        if (link.hasAttribute('data-vlk-angebot-aus-wahl')) {
          var form = link.closest('[data-vlk-kauf]');
          var gewaehlt = form && form.querySelector('input[type="radio"]:checked');
          if (gewaehlt && gewaehlt.getAttribute('data-vlk-name')) name = gewaehlt.getAttribute('data-vlk-name');
        }
        fuelleNachricht('Angebot für: ' + name + '\nMenge: \nUnternehmen / Feuerwehr: ');
        hakeOptionen(name);
      }
      hakeOptionen(link.getAttribute('data-vlk-interesse'));
    } else if (e.target.closest('.rescu-as-pr__cta-btn')) {
      hakeOptionen('Prüfberichte');
    }
  }

  /* ---------- Warenkorb (Muster rescu-krp, Schublade b4c) ---------- */
  function inDenWarenkorb(items) {
    var schublade = document.querySelector('cart-drawer');
    var body = { items: items };
    if (schublade && typeof schublade.getSectionsToRender === 'function') {
      body.sections = schublade.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (res) {
      return res.json().then(function (d) {
        if (!res.ok || d.status) throw new Error(d.description || d.message || 'HTTP ' + res.status);
        return d;
      });
    }).then(function (d) {
      try {
        if (schublade && typeof schublade.renderContents === 'function' && d.sections) {
          schublade.classList.remove('is-empty');
          schublade.renderContents(d);
          return d;
        }
      } catch (fehler) { /* Artikel liegt schon im Korb: nicht erneut senden */ }
      window.location.href = root + 'cart';
      return d;
    });
  }

  function kauf(form) {
    if (form.dataset.vlkBereit) return;
    form.dataset.vlkBereit = '1';
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var items = [];
      var radio = form.querySelector('input[type="radio"][name="id"]:checked');
      if (radio) {
        items.push({ id: +radio.value, quantity: 1 });
      } else {
        var ids = form.querySelectorAll('input[name="items[][id]"]');
        Array.prototype.forEach.call(ids, function (i) { items.push({ id: +i.value, quantity: 1 }); });
      }
      if (!items.length) { form.submit(); return; }
      var knopf = form.querySelector('[data-vlk-kauf-knopf]');
      var text = knopf && knopf.querySelector('span');
      var vorher = text ? text.textContent : '';
      var fehler = form.querySelector('[data-vlk-fehler]');
      if (fehler) { fehler.hidden = true; fehler.textContent = ''; }
      if (knopf) { knopf.setAttribute('aria-busy', 'true'); if (text) text.textContent = 'Wird hinzugefügt …'; }
      inDenWarenkorb(items).then(function () {
        if (!knopf) return;
        knopf.removeAttribute('aria-busy');
        knopf.classList.add('ist-ok');
        if (text) text.textContent = 'Im Warenkorb';
        setTimeout(function () { knopf.classList.remove('ist-ok'); if (text) text.textContent = vorher; }, 2400);
      }).catch(function (err) {
        if (knopf) { knopf.removeAttribute('aria-busy'); if (text) text.textContent = vorher; }
        if (fehler) {
          fehler.textContent = 'Das hat nicht geklappt: ' + (err && err.message ? err.message : 'unbekannter Fehler') + '. Ruf uns gern an: +49 1522 8790057.';
          fehler.hidden = false;
        }
      });
    });
  }

  /* ---------- Szene: startet einmal beim Hereinscrollen ---------- */
  function szene(el) {
    if (el.dataset.vlkBereit) return;
    el.dataset.vlkBereit = '1';
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (e.isIntersecting) { el.classList.add('ist-sichtbar'); io.disconnect(); }
      });
    }, { threshold: 0.35 });
    io.observe(el);
  }

  /* ---------- Schutzkette: Fortschritt beim Scrollen ---------- */
  function fortschritt(root) {
    if (root.dataset.vlkFortschritt) return;
    root.dataset.vlkFortschritt = '1';
    var achse = root.querySelector('.vlk-kette__achse');
    var phasen = Array.prototype.slice.call(root.querySelectorAll('[data-vlk-phase]'));
    if (!phasen.length) return;
    var geplant = false;
    function rechne() {
      geplant = false;
      var mitte = window.innerHeight * 0.5;
      phasen.forEach(function (p) {
        var r = p.getBoundingClientRect();
        var w = (mitte - r.top) / Math.max(1, r.height);
        p.style.setProperty('--vlk-phase-fortschritt', Math.max(0, Math.min(1, w)).toFixed(3));
      });
      if (achse) {
        var a = phasen[0].getBoundingClientRect().top;
        var b = phasen[phasen.length - 1].getBoundingClientRect().bottom;
        var g = (mitte - a) / Math.max(1, b - a);
        achse.style.setProperty('--vlk-kette-fortschritt', Math.max(0, Math.min(1, g)).toFixed(3));
      }
    }
    function plane() { if (!geplant) { geplant = true; window.requestAnimationFrame(rechne); } }
    window.addEventListener('scroll', plane, { passive: true });
    window.addEventListener('resize', plane);
    rechne();
  }

  function start(scope) {
    scope = scope || document;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-vlk-rundgang]'), rundgang);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-vlk-kette]'), function (r) {
      beobachte(r, '[data-vlk-phase]', '[data-vlk-glied]', 'data-vlk-phase', 'data-vlk-glied');
      fortschritt(r);
    });
    Array.prototype.forEach.call(scope.querySelectorAll('[data-vlk-kauf]'), kauf);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-vlk-szene]'), szene);
    Array.prototype.forEach.call(scope.querySelectorAll('[data-vlk-skala]'), function (r) {
      beobachte(r, '[data-vlk-stufe]', '[data-vlk-punkt]', 'data-vlk-stufe', 'data-vlk-punkt');
    });
  }

  if (!window.__vlkKlick) {
    window.__vlkKlick = true;
    document.addEventListener('click', interesse);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { start(); });
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', function (e) { start(e.target); });
})();
